const initApp$ = 'app/initApp$';
const resetApp$ = 'app/resetApp$';
const updateUser$ = 'app/updateUser$';

const INIT_APP_FINISHED = 'app/INIT_APP_FINISHED';

export default {
  INIT_APP_FINISHED,
  initApp$,
  resetApp$,
  updateUser$,
};
